import * as THREE from 'three';
import { SectionConfig, SectionRect, SectionType, SectionInterface, SectionInsets } from '../types';
import { MaterialLibrary } from '../materials/MaterialLibrary';
import { FixSection } from './FixSection';
import { CasementSection } from './CasementSection';
import { TurnTiltSection } from './TurnTiltSection';
import { TiltSection } from './TiltSection';
import { TopHungSection } from './TopHungSection';
import { StolpSection } from './StolpSection';
import { PivotSection } from './PivotSection';
import { SlideHSection } from './SlideHSection';
import { SlideVSection } from './SlideVSection';

export function createSection(
  config: SectionConfig,
  rect: SectionRect,
  materialLib: MaterialLibrary,
  frameMaterial: THREE.Material,
  insets: SectionInsets,
): SectionInterface {
  switch (config.type) {
    case SectionType.FIX:
      return new FixSection(config, rect, materialLib);
    case SectionType.CAS_IN:
    case SectionType.CAS_OUT:
      return new CasementSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.TT:
      return new TurnTiltSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.TILT_IN:
      return new TiltSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.TOPHUNG_OUT:
      return new TopHungSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.STOLP:
      return new StolpSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.PIVOT_V:
      return new PivotSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.SLIDE_H:
      return new SlideHSection(config, rect, materialLib, frameMaterial, insets);
    case SectionType.SLIDE_V:
      return new SlideVSection(config, rect, materialLib, frameMaterial, insets);
    default:
      return new FixSection(config, rect, materialLib);
  }
}
